<template>
  <div>
    <nav class="bar bar-nav">
      <router-link class="button button-link button-nav pull-left" :to="{ name: 'me' }">
        <span class="icon icon-left"></span>
        Back
      </router-link>
      <h1 class="title">我的优惠券</h1>
    </nav>
    <div class="content">
      <div class="list-block media-list" id="myCoupons" style="margin-top: 0px;">
        <ul>
          <li v-for="(coupon, index) in myCoupons" :id="index">
            <div class="item-content">
              <div class="item-inner">
                <div v-if="coupon.applied == 0">
                  <div class="item-title-row">
                    <div class="item-title" style="color: #0894EC;">{{coupon.label}}</div>
                    <div class="item-after" v-if="coupon.type == 1">{{coupon.value | currencyStyle}}</div>
                  </div>
                  <div class="item-subtitle">优惠码：{{coupon.code}}</div>
                  <div class="item-text">有效期：{{coupon.startDT}} 至 {{coupon.endDT}}</div>
                </div>
                <div v-else="coupon.applied == 1">
                  <div class="item-title-row">
                    <div class="item-title" style="color: #0894EC;margin-top: 15px;">{{coupon.label}}</div>
                    <div class="item-after" v-if="coupon.type == 1" style="margin-top: 15px;">{{coupon.value | currencyStyle}}</div>
                    <div>
                      <img src="/emktResources/resocurces/img/used_img.jpg" style="height: 70px;width: 70px">
                    </div>
                  </div>
                  <div class="item-subtitle" style="margin-top: -20px;">优惠码：{{coupon.code}}</div>
                  <div class="item-text">有效期：{{coupon.startDT}} 至 {{coupon.endDT}}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    created () {
      this.fetchData()
    },
    mounted () {
    },
    data () {
      return {
        myCoupons: []
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      'count': function () {
        return this.sessionInfo.expressAddress.length
      }
    },
    watch: {
    },
    methods: {
      fetchData () {
        let customerNo = this.sessionInfo.customerInfo.customerNo
        this.gcapi('getMyCoupons', customerNo).then((res) => {
          this.myCoupons = res.body.result
        })
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// MyDiscount.vue?1d544744